"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleType = void 0;
var RoleType;
(function (RoleType) {
    /**
     * This role is for a user that will be using the public API.
     */
    RoleType["API_USER"] = "API_USER";
    /**
     * This role allows the user to adjust the clients pricing, rates, etc.
     */
    RoleType["PRICING_MANAGER"] = "PRICING_MANAGER";
    /**
     * This role allows the user to:
     *   - assign applications to loan officers
     *   - view all applications for the entire client
     *   - edit applications
     */
    RoleType["LOAN_MANAGER"] = "LOAN_MANAGER";
    /**
     * This role allows the user to:
     *   - view applications assigned to them
     *   - view applications assigned to a team they are on
     *   - edit applications
     *   - submit applications to a LOS
     */
    RoleType["LOAN_TEAM_MEMBER"] = "LOAN_TEAM_MEMBER";
    /**
     * This role allows the user to:
     *   - view applications assigned to them
     *   - view applications assigned to a team they are on
     *   - edit applications
     */
    RoleType["LOAN_PROCESSOR"] = "LOAN_PROCESSOR";
    /**
     * This role allows the user to verify checks
     */
    RoleType["CHECK_VERIFICATION"] = "CHECK_VERIFICATION";
    /**
     * This role allows the user to create teams and delete loans.  Possibly other activities
     * that we only want a few people to have.
     */
    RoleType["SUPER_ADMIN"] = "SUPER_ADMIN";
    /**
     * This role allows the user to perform user management functions (invites/deletes) and
     * other permission related setup.
     */
    RoleType["USER_ADMIN"] = "USER_ADMIN";
    /**
     * Unknown role
     */
    RoleType["UNKNOWN"] = "UNKNOWN";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
